import React from 'react';
import PropTypes from 'prop-types';

import Ottercon from 'components/ottercon';

export default class FileCard extends React.Component {
  static propTypes = {
    file: PropTypes.shape({
      fileName: PropTypes.string.isRequired,
      ottercon: PropTypes.string.isRequired
    }).isRequired,
    onRemove: PropTypes.func
  }

  handleRemove = (e) => {
    e.preventDefault();
    this.props.onRemove();
  };

  render() {
    const { file, onRemove } = this.props;

    return (
      <div className="panel panel-default">
        <div className="panel-body file-card">
          <div className="file-icon">
            <Ottercon ottercon={file.ottercon} size="md" />
          </div>
          <div className="file-name">{file.fileName}</div>
          <div className="file-actions">
            {onRemove &&
              <a href="#" onClick={this.handleRemove}>Remove</a>
            }
          </div>
        </div>
      </div>
    );
  }
}
